/** /channel-partner/hub — Hub overview: counts, CP code, latest services. */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerHubOverview } from '@/features/channel-partner/components/hub-overview';

export const Route = createFileRoute('/_protected/channel-partner/hub/')({
  component: ChannelPartnerHubOverview,
});
